import _i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import global_en from '../languages/EN/global.json';
import global_es from '../languages/ES/global.json';

_i18next
  .use(initReactI18next)
  .init({
      interpolation : {
        escapeValue : false
      },
      lng : localStorage.getItem('language')!== null ? localStorage.getItem('language') : "es",
      resources : {
        es : {
          global : global_es
        },
        en : {
          global : global_en
        }
      }
})

export default _i18next
  